import {useState, useEffect} from "react"

export function useScrollOpacity() {
	const [opacity, setOpacity] = useState(1)

	useEffect(() => {
		const handleScroll = () => {
			const about = document.querySelector("#about") as HTMLElement

			if (about) {
				const scrollTop =
					window.pageYOffset || document.documentElement.scrollTop
				const aboutRect = about.getBoundingClientRect()

				const pagePositionOfAbout = scrollTop + aboutRect.top
				const targetForFullOpacity = pagePositionOfAbout / 2

				setOpacity(
					Math.max(0, Math.min(1, 1 - scrollTop / targetForFullOpacity))
				)
			}
		}

		window.addEventListener("scroll", handleScroll)
		return () => window.removeEventListener("scroll", handleScroll)
	}, [])

	return opacity
}
